import React from 'react';

import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

import Header from '../../components/Header/Header';
import Title from '../../components/Title/Title';

import Navbar from './NavbarFAQ';
import Olimpiada from './Olimpiada';
import Inscricao from './Inscricao';
import Provas from './Provas';
import Premiacao from './Premiacao';

import useStyles from './Style';

import Layout from '../../layouts/public/Public';

const FAQ = () => {
    const classes = useStyles();
    
    return (
        <Layout title="Regulamento">
            <Header />
            
            <Container maxWidth="xl" className={classes.container} >                
                <Grid container spacing={6} >
                    <Grid item xs={12} sm={12} lg={3} xl={3} >
                        <Navbar />
                    </Grid>

                    <Grid item xs={12} sm={12} lg={9} xl={9} >                        
                        <Title variant="h4">
                            PERGUNTAS FREQUENTES
                        </Title>
                        <Typography className={classes.textInitial} variant="body2">
                            Confira as respostas para as perguntas mais frequentes relacionadas à Olimpíada de Professores da OBMEP Mirim. 
                            As perguntas estão separadas por temas. Clique na pergunta para exibir a resposta.
                        </Typography>

                        <Olimpiada />
                        <Inscricao />
                        <Provas />
                        <Premiacao />
                    </Grid>
                </Grid>
            </Container>
        </Layout>
    )
}

export default FAQ;